import { useEffect, useState } from 'react';

/**
 * Ob die Seitenleiste eingeklappt ist — über Sitzungen hinweg.
 *
 * Wer sie zuklappt, will den Chart groß haben; nach einem Neuladen wieder mit
 * halber Breite dazustehen wäre eine Entscheidung, die man täglich wiederholen
 * müsste.
 *
 * Bewusst `localStorage` und nicht der Server: Es ist eine Einstellung dieses
 * Browsers, keine des Kontos. Wer am großen Schirm zuklappt, will das am Laptop
 * nicht zwangsläufig auch.
 *
 * Jeder Zugriff ist abgesichert: Im privaten Fenster und bei gesperrten
 * Website-Daten wirft bereits das Lesen. Eine Anwendung, die daran scheitert,
 * wäre wegen einer Randnotiz nicht mehr bedienbar.
 */

const SCHLUESSEL = 'stockstop.seitenleiste-eingeklappt';

const lesen = (): boolean => {
  try {
    return window.localStorage.getItem(SCHLUESSEL) === 'ja';
  } catch {
    return false;
  }
};

export const useSidebar = (): { eingeklappt: boolean; umschalten: () => void } => {
  const [eingeklappt, setEingeklappt] = useState(lesen);

  useEffect(() => {
    try {
      window.localStorage.setItem(SCHLUESSEL, eingeklappt ? 'ja' : 'nein');
    } catch {
      /* Nicht speicherbar ist kein Grund, die Bedienung zu verweigern — die
       * Einstellung gilt dann nur für diese Sitzung. */
    }
  }, [eingeklappt]);

  return {
    eingeklappt,
    umschalten: () => setEingeklappt((vorher) => !vorher),
  };
};
